module.exports = __webpack_public_path__ + "img/Telegram.d2a640ab.svg";